import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCustomerObjects = (token: string, backend: string, id: number) => {
    return fetch(`${getApiUrl(backend)}customerobjects/customer/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getCustomerObjects